import React, { useState, useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button, Form, Icon, Input } from 'semantic-ui-react';
import InputMask from 'react-text-mask';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import MenuVertical from '../../layouts/MenuVertical';
import Erro from '../../layouts/mensagens/Erro';
import { CabecalhoForm, SecaoForm, AvisoForm, RodapeForm } from '../../layouts/FormUI';
import * as FormValidator from '../../../utils/formValidator';
import { formatDocumento } from '../../../utils/formatador';
import api from '../../../api';

const MASCARA_CPF = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
const MASCARA_CNPJ = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
const MASCARA_CELULAR = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

const VAZIO = { documento: '', nome: '', email: '', celular: '' };

const CadastrarResponsavel = ({ match: { params } }) => {
  const [condominio, setCondominio] = useState({});
  const [form, setForm] = useState(VAZIO);
  const [errors, setErrors] = useState({});
  const [buscando, setBuscando] = useState(false);
  const [existente, setExistente] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sucesso, setSucesso] = useState(null);

  const voltar = `/condominios/${params.id}/responsaveis`;
  const tipoDocumento = form.documento.length > 11 ? 'CNPJ' : 'CPF';

  useEffect(() => {
    api.condominio.findSimpleById(params.id).then(setCondominio).catch(e => setErrors((e.data && e.data.errors) || {}));
  }, [params.id]);

  // procura o proprietário assim que o documento estiver completo e válido
  useEffect(() => {
    const doc = form.documento;
    const valido = (doc.length === 11 && FormValidator.isCpf(doc)) || (doc.length === 14 && FormValidator.isCnpj(doc));
    if (!valido) {
      setExistente(false);
      return undefined;
    }
    let ativo = true;
    setBuscando(true);
    api.responsavel.findByDocumento(doc)
      .then(r => {
        if (!ativo) return;
        setExistente(true);
        setForm(p => ({ ...p, nome: r.nome || '', email: r.email || '', celular: r.celular || '' }));
      })
      .catch(() => ativo && setExistente(false))
      .then(() => ativo && setBuscando(false));
    return () => { ativo = false; };
  }, [form.documento]);

  const onChangeDocumento = e => {
    setErrors({});
    setForm({ ...VAZIO, documento: e.target.value.replace(/\D/g, '') });
  };

  const onChange = ({ target: { name, value } }) => {
    setErrors({});
    setForm(p => ({ ...p, [name]: value }));
  };

  const validate = () => {
    const errs = {};
    if (FormValidator.isVazio(form.documento)) errs.documento = 'Documento é obrigatório';
    else if (!FormValidator.isCpf(form.documento) && !FormValidator.isCnpj(form.documento)) errs.documento = 'Documento inválido';
    if (FormValidator.isVazio(form.nome) || !FormValidator.isNomeCompleto(form.nome)) errs.nome = 'Digite o nome completo';
    if (!FormValidator.isVazio(form.email) && !FormValidator.isEmail(form.email)) errs.email = 'Insira um e-mail válido';
    return errs;
  };

  const onSubmit = async e => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    setLoading(true);
    try {
      const resposta = await api.responsavel.createVinculado({
        ...form,
        tipoDocumento,
        celular: form.celular ? form.celular.replace(/\D/g, '') : '',
        condominio: params.id,
      });
      setSucesso(resposta);
    } catch (err) {
      setErrors((err.data && err.data.errors) || { error: 'Não foi possível cadastrar o proprietário.' });
    }
    setLoading(false);
  };

  const cadastrarOutro = () => {
    setSucesso(null);
    setForm(VAZIO);
    setExistente(false);
  };

  return (
    <div>
      {!!errors.global && <Redirect to="/" />}
      <MenuHorizontal />
      <div className="corpo-dashboard">
        <MenuVertical condominio={condominio} loading={loading} />
        <div className="va-imp-pagina">
          <CabecalhoForm
            voltar={voltar}
            voltarTexto="Proprietários"
            titulo="Cadastrar proprietário"
            descricao="Cadastre o proprietário ou associado. Depois, vincule-o a uma unidade votante."
          />
          {!!errors.error && <Erro text={errors.error} tipo="block" />}

          {sucesso && (
            <div className="va-res-banner sucesso" role="status">
              <Icon name="check circle outline" size="big" />
              <div>
                <b>{sucesso.existente ? 'Proprietário vinculado a este condomínio' : 'Proprietário cadastrado com sucesso'}</b>
                <p>{(sucesso.responsavel && sucesso.responsavel.nome) || form.nome} já pode ser escolhido ao cadastrar uma unidade votante.</p>
                <div className="va-res-acoes">
                  <Link to={`/condominios/${params.id}/unidades/cadastrar`} className="ui button btn-ui-1 small"><Icon name="home" /> Cadastrar unidade votante</Link>
                  <Button size="small" basic onClick={cadastrarOutro}>Cadastrar outro</Button>
                  <Link to={voltar} className="ui basic small button">Ver proprietários</Link>
                </div>
              </div>
            </div>
          )}

          {!sucesso && (
            <Form onSubmit={onSubmit} loading={loading} autoComplete="off" className="va-imp">
              <SecaoForm icone="id card outline" titulo="Documento" descricao="Digite o CPF ou CNPJ: se a pessoa já estiver cadastrada, os dados são preenchidos sozinhos.">
                {buscando && <AvisoForm icone="spinner">Buscando proprietário...</AvisoForm>}
                {existente && !buscando && (
                  <AvisoForm tipo="ok" icone="check circle">Proprietário já cadastrado — ele será vinculado a este condomínio e os dados abaixo não serão alterados.</AvisoForm>
                )}
                <Form.Field error={!!errors.documento} required>
                  <label htmlFor="documento">Documento (CPF ou CNPJ)</label>
                  <Input
                    type="text"
                    children={
                      <InputMask
                        id="documento"
                        name="documento"
                        placeholder="CPF ou CNPJ"
                        onInput={onChangeDocumento}
                        value={formatDocumento(form.documento)}
                        mask={val => (val.replace(/\D/g, '').length <= 11 ? MASCARA_CPF : MASCARA_CNPJ)}
                        guide={true}
                      />
                    }
                  />
                  <Erro text={errors.documento} />
                </Form.Field>
              </SecaoForm>

              <SecaoForm icone="user outline" titulo="Dados do proprietário">
                <Form.Field error={!!errors.nome} required>
                  <label htmlFor="nome">Nome completo</label>
                  <Input id="nome" name="nome" type="text" placeholder="Nome do proprietário" onChange={onChange} value={form.nome} disabled={existente || !form.documento} />
                  <Erro text={errors.nome} />
                </Form.Field>
                <Form.Group widths="equal">
                  <Form.Field error={!!errors.celular}>
                    <label htmlFor="celular">Celular <small>(opcional)</small></label>
                    <InputMask
                      type="text"
                      id="celular"
                      name="celular"
                      placeholder="(ddd) número"
                      mask={MASCARA_CELULAR}
                      guide={true}
                      onChange={onChange}
                      value={form.celular}
                      disabled={existente || !form.documento}
                    />
                    <Erro text={errors.celular} />
                  </Form.Field>
                  <Form.Field error={!!errors.email}>
                    <label htmlFor="email">E-mail <small>(opcional)</small></label>
                    <Input id="email" name="email" type="text" placeholder="E-mail" onChange={onChange} value={form.email} disabled={existente || !form.documento} />
                    <Erro text={errors.email} />
                  </Form.Field>
                </Form.Group>
                <p className="va-imp-dica"><Icon name="info circle" /> O e-mail é necessário para enviar o token de acesso ao aplicativo ao proprietário.</p>
              </SecaoForm>

              <RodapeForm>
                <Button type="submit" loading={loading} disabled={loading} className="btn-ui-1" size="large">
                  <Icon name="save" /> {existente ? 'Vincular ao condomínio' : 'Cadastrar proprietário'}
                </Button>
                <Link to={voltar} className="ui basic large button">Cancelar</Link>
              </RodapeForm>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default CadastrarResponsavel;
